var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('l-map',{staticClass:"map_full",attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_c('l-polygon',{attrs:{"lat-lngs":_vm.polygon,"color":_vm.color}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }